import i18n from '@/lang/i18n'

export default () => {
    return [
        {
            type: 'dateTime',
            headerName: i18n.t('diagnosis.notificationsModal.sentDate'),
            colId: 'timestamp',
            field: 'timestamp',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.notificationsModal.notificationUser'),
            colId: 'createdBy.fullName',
            field: 'createdBy.fullName',
            width: 150,
            minWidth: 280,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.notificationsModal.subject'),
            colId: 'subject',
            field: 'subject',
            width: 150,
            minWidth: 280,
            suppressSizeToFit: true
        }
    ]
}
